<template>
  <h1>Pagina de Prueba</h1>
</template>

<script>
export default {};
</script>

<style></style>
